import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ec2b1242&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=ec2b1242&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec2b1242",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec2b1242')) {
      api.createRecord('ec2b1242', component.options)
    } else {
      api.reload('ec2b1242', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=ec2b1242&scoped=true", function () {
      api.rerender('ec2b1242', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderList/order/dangaoOrder/index.vue"
export default component.exports